import React, { Fragment, useEffect, useState } from "react";
import { GetProducts, getProductsByCategory } from "../../../server/Product";
import { getFilters } from "../../../server/Filter";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Outlet, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ProductEdit = ({ setPendingScrollSlug }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { filterList, product, role, products, stationId, categories } =
    useSelector((state) => ({
      filterList: state.displayProduct.filterList,
      product: state.selectedProduct.product,
      products: state.selectedProduct.products,
      role: state.user.role,
      stationId: state.user.stationId,
      categories: state.selectedProduct.productCategories,
    }));

  useEffect(() => {
    if (role) {
      dispatch(getProductsByCategory(stationId === 1 ? 678430 : stationId, id));

      if (!products?.length) {
        dispatch(GetProducts());
      }

      if (filterList) {
        dispatch(getFilters());
      }

      setTimeout(() => window.scrollTo(0, 0), 200);
    }
  }, [role, id]);

  return product ? (
    <Fragment>
      <h2
        onClick={() => {
          const nav = [...categories[0].categoryHierarchy];
          const reversedNav = [...nav].reverse();
          if (reversedNav.length > 0) {
            const firstCategory = reversedNav[0];
            navigate(`/category/${firstCategory.slug}`);
          }
          if (reversedNav.length > 1) {
            const secondCategory = reversedNav.at(-1);
            setPendingScrollSlug(secondCategory.slug);
          }
        }}
        style={{ cursor: "pointer" }}
      >
        ↪ {product.name} | {product.brandName} |{" "}
        {product.weightDetails?.netContent +
          " " +
          product.weightDetails?.unitOfMeasure}{" "}
        | {product.gtin}
      </h2>

      <div className="tab-header">
        <NavLink to="information" className="tab">
          פרטי מוצר
        </NavLink>
        <NavLink to="logistic" className="tab">
          לוגיסטיקה
        </NavLink>
        <NavLink to="img" className="tab">
          תמונות
        </NavLink>
        <NavLink to="comper" className="tab">
          מחירים
        </NavLink>
        <NavLink to="inventory" className="tab">
          העברת מלאי
        </NavLink>
      </div>
      <div className="outlet">
        <Outlet />
      </div>
    </Fragment>
  ) : null;
};

export default ProductEdit;
